import * as React from 'react';
import { IRestListCopyActivity } from '../../../../../../../../types/rest/activity/IRestListCopyActivity';
import { IRestListActivityBase } from '../../../../../../../../types/rest/activity/IRestListActivityBase';
import { IActivityProps } from '../../types';
import { TActivity } from '../../../../../../../../store/activities/types';
import { ActivityHeader } from '../ActivityHeader/ActivityHeader';
import { ActivityItemBody } from '../ActivityItemBody/ActivityItemBody';
import { AnalyzeRender } from '../../../../../../helpers/memoizeHelper';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`ListActivityCopy`) : null;

export function ListActivityCopy ({
    activity
}: IActivityProps<IRestListCopyActivity>) {
    if (analyzeRender) analyzeRender.call(activity.id);
    const copiedFrom: IRestListActivityBase = {
        ...activity,
        list: {
            id: Number(activity.copiedFromId),
            name: activity.oldValue
        }
    }
    const { label } = activity as TActivity;
    return (
        <ActivityItemBody
            header={<ActivityHeader label={label} />}
            activity={copiedFrom}
        />
    );
}
